import { StyledButtonGroup } from '@app/components/button-group/ButtonGroup';
import { StyledButton } from '@app/components/button/Button';
import { StyledCard } from '@app/components/card/Card';
import { PageMeta } from '@app/components/meta/Meta';
import useAuthActions from '@app/hooks/auth/useAuthActions';
import { fn } from '@app/utils';
import { url } from '@app/utils/constants';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import type { ForgotPasswordFormValues } from './components/ForgotPasswordForm';
import { ForgotPasswordForm } from './components/ForgotPasswordForm';

export const ForgotPassword = () => {
    const { startPasswordReset } = useAuthActions();
    const navigate = useNavigate();
    const [emailSent, setEmailSent] = useState(false);

    const handleForgotPasswordSubmit = async (
        data: ForgotPasswordFormValues
    ) => {
        try {
            await startPasswordReset.mutateAsync(data, {
                onSuccess: () => {
                    setEmailSent(true);
                },
            });
        } catch {
            // Ignore this error as React Query should handle it above
        }
    };

    useEffect(() => {
        if (fn.isLoggedIn()) {
            navigate(url.adminPortal.dashboard);
        }
    }, [navigate]);

    return (
        <>
            <PageMeta title='Forgot Password' />

            <StyledCard showLogo style={{ width: '100%', maxWidth: 680 }}>
                {!emailSent ? (
                    <>
                        <div className='card-intro'>
                            <h1>Forgot Password?</h1>
                            <p>
                                You will receive an email with a link to set a
                                new password.
                            </p>
                        </div>
                        <br />
                        <ForgotPasswordForm
                            onSubmit={handleForgotPasswordSubmit}
                        />
                    </>
                ) : (
                    <>
                        <p className='text-center'>
                            We have sent a password reset link to your email.
                        </p>
                        <StyledButtonGroup justify='center'>
                            <StyledButton
                                htmlType='submit'
                                type='primary'
                                onClick={() => navigate(url.home)}
                            >
                                Go Back to Login
                            </StyledButton>
                        </StyledButtonGroup>
                    </>
                )}
            </StyledCard>
        </>
    );
};

export default ForgotPassword;
